export const CIVILCONTRACT_LOADING = "CIVILCONTRACT_LOADING";
export const CIVILCONTRACT_RESET = "CIVILCONTRACT_RESET";
export const GET_CIVILCONTRACT = "GET_CIVILCONTRACT";
export const GET_CIVILCONTRACT_SUCCESS = "GET_CIVILCONTRACT_SUCCESS";
export const GET_CIVILCONTRACT_FAIL = "GET_CIVILCONTRACT_FAIL";
export const DELETE_CIVILCONTRACT = "DELETE_CIVILCONTRACT"
export const DELETE_CIVILCONTRACT_SUCCESS = "DELETE_CIVILCONTRACT_SUCCESS"
export const DELETE_CIVILCONTRACT_FAIL = "DELETE_CIVILCONTRACT_FAIL"
export const UPDATE_CIVILCONTRACT = "UPDATE_CIVILCONTRACT"
export const UPDATE_CIVILCONTRACT_SUCCESS = "UPDATE_CIVILCONTRACT_SUCCESS"
export const UPDATE_CIVILCONTRACT_FAIL = "UPDATE_CIVILCONTRACT_FAIL"
export const ADD_NEW_CIVILCONTRACT = "ADD_NEW_CIVILCONTRACT"
export const ADD_CIVILCONTRACT_SUCCESS = "ADD_CIVILCONTRACT_SUCCESS"
export const ADD_CIVILCONTRACT_FAIL = "ADD_CIVILCONTRACT_FAIL"